import {
  createContext,
  useContext,
  useMemo,
  type ReactNode,
} from "react";
import { VerticalCode, type VerticalCodeValue } from "../api/org";
import { useOrg } from "./OrgContext";

export interface VerticalContextValue {
  vertical: VerticalCodeValue;
  isLoading: boolean;
}

const VerticalContext = createContext<VerticalContextValue | null>(null);

export function VerticalProvider({ children }: { children: ReactNode }) {
  const { verticalCode, isLoading } = useOrg();

  const value = useMemo<VerticalContextValue>(
    () => ({
      vertical: verticalCode ?? VerticalCode.TRADING,
      isLoading,
    }),
    [verticalCode, isLoading],
  );

  return (
    <VerticalContext.Provider value={value}>{children}</VerticalContext.Provider>
  );
}

export function useVertical(): VerticalContextValue {
  const ctx = useContext(VerticalContext);
  if (!ctx) {
    throw new Error("useVertical must be used within VerticalProvider");
  }
  return ctx;
}

export { VerticalCode };
